var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_370",
    width: 16.41,
    height: 16.41,
    "data-name": 370,
    viewBox: "0 0 16.41 16.41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M1.41 16.41l6.8-6.79L15 16.41 16.41 15 9.62 8.21l6.79-6.8L15 0 8.21 6.79 1.41 0 0 1.41l6.79 6.8L0 15z",
    "data-name": "Path 38"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close_icon.6ddc8b0a.svg";
export { ForwardRef as ReactComponent };